import { useCallback } from "react";

import { FormattedMessage } from "react-intl";

import { useAppUpdate } from "app/hooks/useAppUpdate";
import { useLayoutStore } from "app/stores/useLayoutStore";
import { Button } from "ui/Button/Button";
import { Modal } from "ui/Modal/Modal";
import { BodyM, HeaderS } from "ui/Typography/Typography";

const closeUpdateAppModal = () => useLayoutStore.setState({ showUpdateAppModal: false });

export function UpdateAppModal() {
  const showUpdateAppModal = useLayoutStore((state) => state.showUpdateAppModal);

  const updateApp = useAppUpdate();

  const onClickUpdateNow = useCallback(() => {
    updateApp();
  }, [updateApp]);

  return (
    <Modal
      trapFocus={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={showUpdateAppModal}
      onClose={() => {}}
    >
      <Modal.Content marginX="s300">
        <Modal.Body display="flex" flexDir="column" alignItems="center" textAlign="center" p="s200">
          <HeaderS mt="s200">
            <FormattedMessage id="core.components.update-app-modal.title" />
          </HeaderS>
          <BodyM mt="s100" color="grey.700">
            <FormattedMessage id="core.components.update-app-modal.description" />
          </BodyM>
        </Modal.Body>
        <Modal.Footer paddingX="s200" pt="s100" flexDir="column">
          <Button onClick={onClickUpdateNow} variant="primary" size="lg" isFullWidth>
            <FormattedMessage id="core.components.update-app-modal.update-now" />
          </Button>
          <Button mt="s100" onClick={closeUpdateAppModal} variant="secondary" size="lg" isFullWidth>
            <FormattedMessage id="core.components.update-app-modal.update-later" />
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
